import { TreatmentApproach, TreatmentApproachIntervention } from '@uplift/types';
import { restClient } from '../client';

export type GetTreatmentApproachesResponse = {
  data: TreatmentApproach[];
};

export const getTreatmentApproaches = async () => {
  return await restClient.request<GetTreatmentApproachesResponse>('/api/v1/treatment_approach');
};

export const getTreatmentApproachInterventions = async (treatmentApproachId?: string) => {
  return await restClient.request<{
    data: TreatmentApproachIntervention[];
  }>('/api/v1/interventions', {
    method: 'GET',
    params: {
      treatment_approach_id: treatmentApproachId,
    }
  });
};
